// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"81256e0a","498":"727da1a8","703":"6c5a7ab6","787":"1e4dd49c"}[chunkId] + ".chunk.js";
};